
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1t44z_uf2dl_9",
  "popover-body": "awsui_popover-body_1t44z_uf2dl_42",
  "footer": "awsui_footer_1t44z_uf2dl_46"
};
  